import { useEffect, useState } from "react";

export function getInitialMode() {
  try {
    return localStorage.getItem("theme-mode") === "dark" ? "dark" : "light";
  } catch {
    return "light";
  }
}

export function useThemeMode() {
  const [mode, setMode] = useState(getInitialMode);

  useEffect(() => {
    document.documentElement.dataset.theme = mode;
    try {
      localStorage.setItem("theme-mode", mode);
    } catch {}
  }, [mode]);

  return { mode, setMode };
}
